<template>
    <div class="flex-col page">
        <div class="flex-col group_3">
            <div class="section_1"></div>
            <div class="flex-col section_2">
                <div class="justify-between group_4">
                    <span class="text_3">兑换码可兑换相应 会员/卡包</span>
                    <div class="flex-row">
                        <span class="text_4" @click="goCouponList">我的卡劵</span>
                        <img src="https://imgpub1.shouqiev.com/gofunplatform/files/20220819/qraJTQsjKz.png"
                            class="image_4" />
                    </div>
                </div>
                <div class="flex-col group_6">
                    <input type="text" placeholder="请输入兑换码" v-model="exchangeCode" class="text-wrapper_1 text_5" />
                    <div class="flex-col items-center button" @click="exchange">
                        <span class="text_6">立即兑换</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { exchangeRedeemCode } from "../api";
export default {
    data() {
        return {
            exchangeCode: "",
        };
    },
    methods: {
        exchange() {
            exchangeRedeemCode({
                redeemCode: this.exchangeCode,
                orderId: this.$route.query.orderId,
            }).then((res) => {
                if (res.code == 200) {
                    this.goCouponList();
                }
            });
        },
        goCouponList() {
            this.$router.push({
                path: "/salePassat/couponList",
                query: { orderId: this.$route.query.orderId },
            });
        },
    },
};
</script>

<style scoped lang="scss">
@import '../common.css';
.page {
    padding-top: 0.027rem;
    background-color: #f5f5f5;
    width: 100%;
    overflow-x: hidden;
    height: 100%;

    .group_3 {
        height: 16.08rem;
        overflow-y: auto;

        .section_1 {
            flex-shrink: 0;
            background-color: #d8d8d8;
            height: 5.63rem;
            background: url(https://imgpub1.shouqiev.com/gofunplatform/files/20220815/iGGffMnTMY.png) no-repeat;
            background-size: contain;
        }

        .section_2 {
            margin-top: -0.4rem;
            padding: 0.43rem 0 6.64rem;
            background-color: #ffffff;
            border-radius: 0.43rem 0.43rem 0px 0px;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 5.63rem;

            .group_4 {
                padding-left: 0.45rem;
                padding-right: 0.43rem;

                .text_3 {
                    color: #333333;
                    font-size: 0.43rem;
                    font-family: "PingFang SC";
                    font-weight: 500;
                    line-height: 0.59rem;
                }

                .text_4 {
                    color: #999999;
                    font-size: 0.37rem;
                    font-family: "PingFang SC";
                    font-weight: 500;
                    line-height: 0.53rem;
                }

                .image_4 {
                    margin: 0.053rem 0 0.053rem 0.11rem;
                    flex-shrink: 0;
                    width: 0.21rem;
                    height: 0.43rem;
                }
            }

            .group_6 {
                margin-top: 0.43rem;
                padding: 0 0.43rem;

                .text-wrapper_1 {
                    padding: 0.32rem;
                    background-color: #f7f7f7;
                    border-radius: 0.21rem;
                }

                .text_5 {
                    color: #999999;
                    font-size: 0.37rem;
                    font-family: "PingFang SC";
                    line-height: 0.53rem;
                }

                .button {
                    margin: 0.43rem 0.11rem 0;
                    padding: 0.35rem 0 0.32rem;
                    background-color: #02d644;
                    border-radius: 0.59rem;

                    .text_6 {
                        color: #ffffff;
                        font-size: 0.43rem;
                        font-family: "FZLanTingHeiS-DB-GB";
                        line-height: 0.51rem;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// exchangeCouponCode.vue?01a71002